import { Injectable } from '@angular/core';
import {
    AbstractControl,
    FormGroupDirective,
    NgForm,
} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';

@Injectable({
    providedIn: 'root',
})
export class UiErrorStateMatcher implements ErrorStateMatcher {
    isErrorState(control: AbstractControl | null, form: FormGroupDirective | NgForm | null) {
        return !!(
            control &&
            control.invalid && (
                control.touched ||
                control.dirty ||
                (form && form.submitted)
            )
        );
    }
}
